import React, {ReactNode, useEffect} from 'react';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import {CssBaseline} from '@mui/material';

import {useHostName} from 'presentation/hooks/useHostName';
import {DEFAULT_THEME_BY_PRODUCT, FAVICON_BY_PRODUCT} from 'presentation/constants';

import {GlobalStyles} from './global.styles';
import {useThemeStore} from 'presentation/store/useThemeStore';

interface ThemeProviderProps {
	children: ReactNode;
}

export const ThemeType = ({children}: ThemeProviderProps) => {
	const theme = useThemeStore(state => state.theme);
	const setTheme = useThemeStore(state => state.setTheme);
	const {dataHostNameState} = useHostName();

	useEffect(() => {
		if (dataHostNameState) {
			setTheme(DEFAULT_THEME_BY_PRODUCT[dataHostNameState.product]);
		}
	}, [dataHostNameState, setTheme]);

	useEffect(() => {
		const favicon = document.getElementById('favicon') as HTMLElement;

		if (dataHostNameState) {
			favicon?.setAttribute('href', FAVICON_BY_PRODUCT[dataHostNameState.product]);
		}
	}, [dataHostNameState]);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<GlobalStyles />
			{children}
		</ThemeProvider>
	);
};
